import { ApiClientError } from './ApiClientError';

/**
 * バリデーションエラー
 */
export class ValidationError extends ApiClientError {
  override name = 'ValidationError';
  /** エラー内容 */
  validationErrors: string[];

  constructor(
    status: string,
    message: string,
    errorId: string,
    displayId: string,
    validationErrors: string[]) {
    super(status, message, errorId, displayId);
    this.validationErrors = validationErrors;
  }
}
